export const responseRegex = /<response[\s\S]+<\/response>/;

export const keyValuePairRegex = /(\w+="\w*")/g;

export const successRegex = /success="(true|false)"/;

export const codeRegex = /code="(\w*)"/;

export const statusRegex = /status="(\d*)"/;
